export default {
    all_payments: [],
    all_rescues_closed: [],
    all_rescues_open: [],
    is_money_visible: true,
    last_payments_display_as: 'accumulated_by_period', // accumulated_by_period ou all_rescues
    available_for_redemption: null,
    credits_under_review: {
        data: null,
        pages_already_loaded: []
    },
    credits_rescued_details: null,
    data_values_received_and_to_be_received: null,
    type_of_services_allowed: 'all', // all, only_money, only_gift_card
    last_page_of_pagination: 1,
    current_page_of_pagination: 1,
    pages_already_loaded: [],
    current_key_refresh_components: 1,
    is_reloading_components: false,
    is_services_loaded_in_index_component: false
}